import React from 'react';
import PropTypes from 'prop-types';
import { wrapFunctionalComponent } from 'utils/framework';
import { Grid } from 'components/ui';
import RecapItem from 'components/Content/Recap/RecapItem';
import RecapImage from 'components/Content/Recap/RecapImage';

const MAX_THUMBNAILS = 4;
const THUMBNAIL_SIZE = [122, 166];

function RecapKeepShoppingFor({ products, ...props }) {
    const tiles = Array.isArray(products) ? products.slice(0, MAX_THUMBNAILS) : [];

    return (
        <RecapItem
            {...props}
            displayTitle={props.title}
        >
            <Grid
                columns={2}
                gap={[1, 2]}
            >
                {tiles.map((product, index) => (
                    <div key={product.skuId || index}>
                        <RecapImage
                            sku={product}
                            size={THUMBNAIL_SIZE}
                            showPlaceholderOnError={true}
                        />
                    </div>
                ))}
            </Grid>
        </RecapItem>
    );
}

RecapKeepShoppingFor.propTypes = {
    products: PropTypes.array,
    title: PropTypes.string,
    targetUrl: PropTypes.string,
    sid: PropTypes.string,
    isLoading: PropTypes.bool,
    triggerClick: PropTypes.func
};

export default wrapFunctionalComponent(RecapKeepShoppingFor, 'RecapKeepShoppingFor');
